<template>
  <div class="Home">
    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <table data-sort="sortDisabled" align="center" width="930">
          <tbody>
            <tr class="firstRow">
              <td
                valign="top"
                rowspan="1"
                colspan="15"
                style="word-break: break-all;"
                align="center"
                width="1041"
              >
                <h3
                  data-v-90af21ba=""
                  style="box-sizing: border-box; margin: 0px; font-weight: 500; line-height: 1.2; font-size: 1.75rem; border: none; font-family: 微软雅黑, 黑体, 宋体; padding: 2.8125rem 5rem 0; text-align: center; color: rgb(51, 51, 51); white-space: normal;"
                >
                  平台优势
                </h3>
                <p
                  style="display: block;width: 1.5625rem; height: .1875rem; background-color: #333; margin: .625rem auto 0;"
                >
                  <br />
                </p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                <p>
                  <span
                    style="color: rgb(153, 153, 153); font-family: 微软雅黑, 黑体, 宋体; text-align: center; background-color: rgb(248, 248, 248);"
                    >打破专业建设壁垒，培养复合型应用人才</span
                  >
                </p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="66" valign="top"><br /></td>
              <td width="67" valign="top"><br /></td>
              <td
                width="69"
                valign="top"
                style="word-break: break-all;"
                align="center"
              >
                <br />
              </td>
              <td width="70" valign="top"><br /></td>
              <td width="70" valign="top"><br /></td>
              <td width="70" valign="top"><br /></td>
              <td width="70" valign="top"><br /></td>
              <td width="69" valign="top"><br /></td>
              <td width="70" valign="top"><br /></td>
              <td width="70" valign="top"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
            </tr>
            <tr>
              <td width="66" valign="top"><br /></td>
              <td width="67" valign="top"><br /></td>
              <td
                valign="middle"
                rowspan="1"
                colspan="1"
                style="word-break: break-all;"
                width="69"
                align="center"
              >
                <p style="text-align:center">
                  <br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
                <p>
                  <br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
              </td>
              <td
                rowspan="2"
                valign="middle"
                align="center"
                style="word-break: break-all; border:1px solid #ccc;"
                colspan="4"
                width="280"
              >
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                <p style="text-align:center">
                  <img
                    :src="require('../../../../assets/colleges/J5L34hvfEB0N04DA379k948b2Hp1591241811141.png')"
                    title="df251d85daca23173360d6bdb19f104.png"
                    alt="df251d85daca23173360d6bdb19f104.png"
                  />
                </p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                <p>
                  <strong
                    ><span style="font-size: 20px;"
                      >课程体系接轨行业</span
                    ></strong
                  ><br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp;
                </p>
                <p>结合企业产业需求，规划系统的课程体系，</p>
                <p>全面培养学生结构化能力，跨专业融合共享。</p>
                <p>
                  <br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
              </td>
              <td width="69" valign="top"><br /></td>
              <td
                valign="middle"
                rowspan="2"
                style="word-break: break-all;border:1px solid #ccc;"
                colspan="4"
                align="center"
                width="280"
              >
                <p><br /></p>
                <p>
                  <img
                    :src="require('../../../../assets/colleges/DZy8C93n1P31733NJYXaj851Hp21591241301960.png')"
                    title="a42dd0b9d50ba3be0870261bdf47009.png"
                    alt="a42dd0b9d50ba3be0870261bdf47009.png"
                    width="68"
                    height="68"
                    border="0"
                    vspace="0"
                    style="width: 68px; height: 68px;"
                  />
                </p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                <p>
                  <strong
                    ><span style="font-size: 20px;"
                      >构建主流实训环境</span
                    ></strong
                  ><br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp;
                </p>
                <p>灵活部署，快速构建主流AI场景及实训环境，</p>
                <p>实现教学数字化转身。</p>
                <p>
                  <br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                </p>
              </td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
            </tr>
            <tr>
              <td valign="top" colspan="1" rowspan="1" width="66"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="67"><br /></td>
              <td
                colspan="1"
                valign="middle"
                align="center"
                style="word-break: break-all;"
                width="69"
              >
                <br />
              </td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
            </tr>
            <tr>
              <td valign="top" colspan="1" rowspan="1" width="66"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="67"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
            </tr>
            <tr>
              <td valign="top" colspan="1" rowspan="1" width="66"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="67"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
            </tr>
            <tr>
              <td valign="top" colspan="1" rowspan="1" width="66"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="67"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="70"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="69"><br /></td>
            </tr>
          </tbody>
        </table>
        <p><br /></p>
        <table data-sort="sortDisabled" align="center" width="930">
          <tbody>
            <tr class="firstRow">
              <td
                valign="middle"
                rowspan="1"
                colspan="8"
                align="center"
                style="word-break: break-all;"
                width="1044"
              >
                <h3
                  data-v-90af21ba=""
                  style="box-sizing: border-box; margin: 0px; font-weight: 500; line-height: 1.2; font-size: 1.75rem; border: none; font-family: 微软雅黑, 黑体, 宋体; padding: 0px; color: rgb(51, 51, 51);"
                >
                  平台资源
                </h3>
                <p><br /></p>
                <p>
                  <img
                    :src="require('../../../../assets/colleges/PFaWX8q8h302Wv1qD88OG4jlU181590636331387.png')"
                    title="image.png"
                    alt="image.png"
                  />
                </p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                <p>
                  <span
                    style="color: rgb(153, 153, 153); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(248, 248, 248);"
                    >华为原厂核心技术，配置主流运行场景，优化实验教学效果</span
                  >
                </p>
                <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="111" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="112" valign="top" style="word-break: break-all;">
                <br />
              </td>
            </tr>
            <tr>
              <td
                valign="top"
                rowspan="1"
                colspan="1"
                width="111"
                style="word-break: break-all;"
              >
                <br />
              </td>
              <td
                valign="middle"
                rowspan="2"
                colspan="3"
                style="word-break: break-all;"
                width="410"
                align="center"
              >
                <p style="text-align:center">
                  <img
                    :src="require('../../../../assets/colleges/699M41c212O2Rkw2Klw27X2080m1665456670307.jpg')"
                    title="【高校用户】产品与解决方案-移动通信专业-实训室建设-平台资源（左）.jpg"
                    alt="【高校用户】产品与解决方案-移动通信专业-实训室建设-平台资源（左）.jpg"
                  />
                </p>
                <p><br /></p>
                <p>
                  <img
                    :src="require('../../../../assets/colleges/70bU100WjWY59xP0k31Q9Z9hC901666078619620.png')"
                    title="移动通信专业-实训室建设-平台资源.png"
                    alt="移动通信专业-实训室建设-平台资源.png"
                    width="500"
                    height="349"
                    border="0"
                    vspace="0"
                    style="width: 500px; height: 349px;"
                  />
                </p>
                <p>
                  <span style="font-size: 20px;"><br /></span>
                </p>
                <p>
                  <span style="font-size: 16px;"
                    >还原现网体验，满足六大教学场景</span
                  ><span style="font-size: 20px; text-align: -webkit-left;"
                    >&nbsp;</span
                  ><br />
                </p>
                <p>
                  <span style="font-size: 14px;"><br /></span>
                </p>
                <p>
                  采用远程登录访问华为全球培训中心5G真实设备，包含5G无线接入网(RAN)
                  和云化核心网(NGC)两部分。其中RAN即GNODEB,负责无线信令的建立、切换和拆除;云化核心网负责实现按需的业务切片，满足不同场景的QOS需求。5G
                  E-LAB实训环境能够最大程度接近现网体验，操作界面和配置流程与真实华为基站操作平台相同，采用拉远方式部署在院校实训室，满足从硬件配置、数据配置、信令分析、覆盖分析、到操作维护、业务验证的6大场景教学需求。
                </p>
                <p><br /></p>
              </td>
              <td
                valign="top"
                rowspan="2"
                colspan="3"
                style="word-break: break-all;"
                width="410"
                align="center"
              >
                <p style="text-align:center">
                  <img
                    :src="require('../../../../assets/colleges/3ta2O23n1Q1Y1ihzdK9C0Pr1oa51665456681279.jpg')"
                    title="【高校用户】产品与解决方案-移动通信专业-实训室建设-平台资源（右）.jpg"
                    alt="【高校用户】产品与解决方案-移动通信专业-实训室建设-平台资源（右）.jpg"
                  />
                </p>
                <p><br /></p>
                <p>
                  <img
                    :src="require('../../../../assets/colleges/781h34Pm3zPO0VNft1h29s7k48P1665456733490.png')"
                    title="20220924-153243(WeLinkPC).png"
                    alt="20220924-153243(WeLinkPC).png"
                    width="500"
                    height="349"
                    border="0"
                    vspace="0"
                    style="width: 500px; height: 349px;"
                  />
                </p>
                <p>
                  <span style="font-size: 20px;"><br /></span>
                </p>
                <p>
                  <span style="font-size: 16px;"
                    >真实场景、极简操作、实践应用、节省成本</span
                  ><br />
                </p>
                <p>
                  <span style="text-align: -webkit-left; font-size: 14px;"
                    ><br
                  /></span>
                </p>
                <p>
                  基于华为5G基站同源环境开发的软件产品。它是将操作平台和虛拟仿真技术完美结合的的5G学习模拟软件，为学习者创造更加灵活真实的实验环境，满足5G人才培养过程中对真实场景、极简操作、实践应用和节省成本的需求。支持BBU/RRU基站硬件安装、小区覆盖建模、UE驻留选择、基站参数配置、网络拓扑管理和业务体验(视频下载、网页浏览、时延检测等)等功能。聚焦3D场景下的天馈、板卡、线缆安装，内置WEBLMT高效数据维护无线、传输、设备层，实现告警和版本管理，支撑语音、视频等业务验证。
                </p>
              </td>
              <td valign="top" rowspan="1" colspan="1" width="112"><br /></td>
            </tr>
            <tr>
              <td valign="top" rowspan="1" colspan="1" width="111"><br /></td>
              <td valign="top" rowspan="1" colspan="1" width="112"><br /></td>
            </tr>
            <tr>
              <td width="111"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="112"><br /></td>
            </tr>
            <tr>
              <td width="111"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="136"><br /></td>
              <td width="112"><br /></td>
            </tr>
            <tr>
              <td width="111" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top"><br /></td>
              <td width="136" valign="top" style="word-break: break-all;">
                <br />
              </td>
              <td width="136" valign="top" style="word-break: break-all;">
                <br />
              </td>
              <td width="136" valign="top" style="word-break: break-all;">
                <br />
              </td>
              <td width="136" valign="top" style="word-break: break-all;">
                <br />
              </td>
              <td width="112" valign="top" style="word-break: break-all;">
                <br />
              </td>
            </tr>
            <tr>
              <td valign="top" colspan="1" rowspan="1" width="111"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="136"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="136"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="136"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="136"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="136"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="136"><br /></td>
              <td valign="top" colspan="1" rowspan="1" width="112"><br /></td>
            </tr>
          </tbody>
        </table>
        <p><br /></p>
        <div
          id="baidu_pastebin"
          style="position: absolute; width: 1px; height: 1px; overflow: hidden; left: -1000px; white-space: nowrap; top: 152px;"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
p {
  // padding-top: 10px;
  margin-bottom: 0;
  font-size: 16px;
}
table {
  width: 100% !important;
}
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
  max-width: 1366px;
  margin: 0 auto;
}
.conent_box {
  background-color: #f8f8f8;
  padding: 5% 0 0 !important;
  margin-bottom: 1.25rem;
  h3 {
    font-size: 1.75rem;
    text-align: center;
    color: #333;
  }
  .selected {
    display: block;
    width: 1.5625rem;
    height: 0.1875rem;
    background-color: #333333;
    margin: 0.625rem auto 0;
  }
  ._text {
    width: 100% !important;
    text-align: center;
    color: #999999;
    margin: 1.25rem auto 1.875rem;
  }
  // 平台优势
  .personnel {
    display: flex;
    padding: 0 10% 4.0625rem;
    justify-content: center;
    /deep/ li {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 16.5625rem;
      width: 20.1875rem;
      align-items: center;
      padding: 0 0.9375rem 0;
      margin: 0 6px;
      color: #333;
      border: 1px solid #ccc;
      .personnel1 {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding-bottom: 1.5rem;
        width: 64px;
        img {
          width: 100%;
        }
      }
      .personnel2 {
        flex: 1;
        display: flex;
        flex-direction: column;
        h3 {
          font-size: 1.25rem;
          font-weight: 700;
          // padding-top: 0.875rem;
        }
        p {
          font-size: 0.875rem;
          text-align: center;
          color: #acacac;
          line-height: 160%;
          padding-top: 10px;
        }
      }
    }
  }
}
// 平台资源
.resources {
  padding: 2.8125rem 5.625rem 0;
  // 课程
  .course {
    margin-top: 5rem;
    display: flex;
    .course_box {
      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      flex: 1;
      font-size: 1.5rem;
      h3 {
        text-align: left;
        font-size: 1.5rem;
        font-weight: 700;
      }
      p {
        font-size: 1.125rem;
        color: #999;
        padding-top: 10px;
      }
      .form_box {
        li {
          padding-top: 1.25rem;
          font-size: 1.125rem;
          div {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            i {
              display: inline-block;
              width: 0.1875rem;
              height: 0.1875rem;
              background-color: #dd0011;
              border-radius: 50%;
              margin-top: 22px;
            }
            p {
              width: 98%;
              color: #333;
            }
          }
        }
      }
    }
    .course_img {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      position: relative;
      .pink {
        width: 30rem;
        height: 24.0625rem;
        background-color: pink;
      }
      img {
        position: absolute;
        top: 2.5rem;
        right: 2.5rem;
        width: 30rem;
        height: 24.0625rem;
      }
    }
  }
  ._text {
    color: #999999;
  }
  ._text1 {
    text-align: center;
  }
  // 环境
  .surroundings {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 1.5rem;
    h3 {
      text-align: left;
      font-size: 1.5rem;
      font-weight: 700;
    }
    p {
      font-size: 1.125rem;
      font-weight: 700;
      color: #dd0011;
    }
    /deep/ .application {
      font-size: 1rem;
      color: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      /deep/ li {
        width: 40%;
        display: flex;
        flex-direction: column;
        margin: 1.875rem 25px;
        /deep/ .application_title {
          width: 100% !important;
          height: 136px;
          background: url("../../../../assets/application.png");
          background-size: 100% 136px;
          background-repeat: no-repeat;
          font-size: 20px;
          text-align: center;
          border-radius: 5px;
          padding: 20px 14px 1px;
          span {
            display: block;
            font-size: 14px;
          }
        }
        .application_img {
          width: 100% !important;
          img {
            width: 100% !important;
          }
          margin: 15px auto 27px;
        }
        .application_text {
          h4 {
            font-size: 20px;
            color: #333;
          }
          p {
            text-align: justify;
            text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
            font-size: 14px;
            color: #666;
            font-weight: 400;
          }
        }
      }
    }
  }
  // 开发工具
  .open {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      height: 15.8125rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0.3125rem;
      box-shadow: 0 0 3px 1px #ccc;
      padding: 1.75rem 0;
      div {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          // height: 100%;
          margin: 0 auto;
        }
      }
      p {
        font-size: 1.125rem;
        text-align: center;
        color: #333333;
        font-weight: 700;
        // padding-top: 1.25rem;
      }
    }
  }
  // 开发工具介绍
  .introduction {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      height: 12.5rem;
      display: flex;
      flex-direction: column;
      padding-top: 1.875rem;
      h4 {
        font-size: 1.5rem;
        margin: 0;
      }
      p {
        font-size: 0.875rem;
        color: #333333;
        padding-top: 1.125rem;
      }
    }
  }
  // 主流网站
  .website {
    font-size: 1.125rem;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    .website_head {
      color: #dd0011;
    }
    .website_box {
      display: flex;
      flex-wrap: wrap;
      padding: 1.5625rem 0 1.25rem;
      .web {
        .website_box_git {
          width: 13rem;
          height: 7.3125rem;
          background-color: #fff;
          margin-right: 1.25rem;
          border-radius: 0.3125rem;
          img {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        p {
          text-align: center;
          padding: 1.25rem 0 1.875rem;
        }
      }
    }
  }
}
// 平台支撑
.support {
  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
  }
  .red {
    color: #dd0011;
    font-weight: 600;
  }
  .support_box {
    padding: 0 4.375rem;
    display: flex;
    justify-content: space-between;
    li {
      width: 25rem;
      height: 13.3125rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      img {
        width: 4.3125rem;
        height: 2.75rem;
      }
      div {
        h3 {
          font-size: 1.5rem;
          color: #333;
        }
        p {
          font-size: 0.875rem;
          text-align: center;
          color: #555555;
        }
      }
    }
  }
  h4 {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .support_h4 {
    margin-top: 50px;
    color: #333;
  }
  .support_p {
    text-align: center;
  }
  .support_img {
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .advantage {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    h5 {
      font-size: 1.25rem;
      font-weight: 600;
      color: #333;
    }
    .advantage_left {
      width: 34.1875rem;
      margin-top: 2.125rem;
      padding-right: 9rem;
      display: flex;
      flex-direction: column;
      text-align: right;
    }
    .advantage_right {
      width: 36.375rem;
      margin-top: 2.125rem;
      padding-left: 11rem;
      display: flex;
      flex-direction: column;
    }
    .advantage_right_1 {
      padding-left: 14rem;
      margin-top: 35px;
    }
    .advantage_left_1 {
      padding-right: 12rem;
      margin-top: 35px;
    }
  }
}
.conent {
  width: 100%;
  /deep/ table {
    width: 100%;
    &:nth-child(3) {
      width: 100%;
      /deep/ tbody {
        /deep/ tr {
          &:nth-child(3) {
            td {
              &:nth-child(2) {
                /deep/ p {
                  text-align: left;
                  padding: 0 5%;
                }
              }
              &:nth-child(3) {
                /deep/ p {
                  text-align: left;
                  padding: 0 5%;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) and (min-width: 1200px) {
  .WidCon {
    padding: 0 5%;
  }
  .conent {
    /deep/ table {
      width: 100%;
      &:nth-child(1) {
        // width: 80px !important;
        tbody {
          .firstRow {
            td {
              width: 100%;
            }
          }
          tr {
            display: flex;
            &:nth-child(3) {
              td {
                width: 2%;
                &:nth-child(1) {
                  display: none;
                }
                &:nth-child(4),
                &:nth-child(6) {
                  flex: 30%;
                }
              }
            }
            display: flex;
            flex-wrap: wrap;
            td {
              &:nth-child(1) {
                // display: none;
              }
            }
          }
        }
      }
      &:nth-child(3) {
        width: 100%;
        tbody {
          display: flex;
          flex-direction: column;
          align-items: center;
          tr {
            &:nth-child(3) {
              display: flex;
              flex-direction: column;
              flex: 100%;
              td {
                &:nth-child(3),
                &:nth-child(2) {
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  p {
                    display: flex;
                    text-align: center;
                  }
                }
                &:nth-child(3) {
                  p {
                    &:nth-child(7) {
                      padding: 0 10%;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) and (min-width: 768px) {
  .WidCon {
    padding: 0 5%;
  }
  .conent {
    /deep/ table {
      &:nth-child(3) {
        tbody {
          display: flex;
          flex-direction: column;
          align-items: center;
          tr {
            &:nth-child(3) {
              display: flex;
              flex-direction: column;
              align-items: center;
              flex: 100%;
              td {
                &:nth-child(3),
                &:nth-child(2) {
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  p {
                    display: flex;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .conent {
    /deep/ table {
      &:nth-child(1) {
        // width: 80px !important;
        tbody {
          .firstRow {
            td {
              width: 100%;
            }
          }
          tr {
            display: flex;
            &:nth-child(n + 4),
            &:nth-child(2) {
              display: none;
            }

            &:nth-child(3) {
              display: flex;
              flex-direction: column;
              td {
                width: 100%;

                &:nth-child(-n + 3) {
                  display: none;
                }
                &:nth-child(4),
                &:nth-child(6) {
                  flex: 100%;
                }
              }
            }
          }
        }
      }
      &:nth-child(3) {
        tbody {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          tr {
            width: 100%;
            &:nth-child(3) {
              display: flex;
              flex-direction: column;
              align-items: center;
              flex: 100%;
              img {
                width: 100% !important;
                height: auto !important;
              }
              td {
                &:nth-child(2) {
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  p {
                    display: flex;
                    text-align: center;
                  }
                }
                &:nth-child(3) {
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  p {
                    display: flex;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  .conent_box {
    // 平台优势
    .personnel {
      padding: 0 0 30px;
      flex-direction: column;
      align-items: center;
      li {
        margin-bottom: 5px;
      }
    }
  }
  // 平台资源
  .resources {
    padding: 2.8125rem 0.3125rem 0;
    ._text {
      margin: 5px auto 10px;
      font-size: 16px;
    }
    // 课程
    .course {
      margin-top: 0;
      flex-direction: column;
      .course_img {
        margin-top: 0.625rem;
      }
    }
    // 环境
    .surroundings {
      .application {
        flex-direction: column;
        height: 100%;
        /deep/ li {
          .application_title {
            font-size: 18px;
            padding: 15px;
            height: auto;
            margin: 0;
            span {
              font-size: 12px;
            }
          }
          width: 100%;
          margin: 0.625rem auto;
        }
      }
    }
    // 开发工具
    .open {
      flex-direction: column;
      align-items: center;
      li {
        margin: 0.625rem auto;
        div {
          overflow: hidden;
        }
      }
    }
    // 开发工具介绍
    .introduction {
      flex-direction: column;
      li {
        width: 100%;
      }
    }
    // 主流网站
    .website {
      .website_box {
        justify-content: space-around;
      }
    }
  }
  // 平台支撑
  .support {
    .support_box {
      flex-direction: column;
      align-items: center;
    }
    .support_img {
      img {
        opacity: 0;
      }
    }
    .advantage {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .advantage_left {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_right {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_right_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_left_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
    }
  }

  .conent_box h3 {
    font-size: 18px;
  }

  .conent_box {
    padding-top: 20px;
  }

  .conent_box .personnel li .personnel2 h3 {
    font-size: 16px;
    font-weight: bold;
  }

  .resources .surroundings .application li .application_text h4 {
    font-size: 16px;
  }

  .application_text {
    padding: 0 10px;
  }
}
</style>
